import Label from '@zacousticrepo/grommet-v1-custom/components/Label';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory as history, Link } from 'react-router';
import Close from "@material-ui/icons/Close";
import { pageLoaded, isDefined, arrayIsNotEmpty } from '../../../../../utils';
import BackArrowIcon from '../../../../../icons/v3/BackArrowIcon';
import SelectTable from '../../../../../components/v3/CalibrationScreenV3/SelectTable';

import AgentAuditsSummary from './AgentAuditsSummary';

import {
    loadQaCoachScreen,
    postCoachingSession,
    updateProps
} from '../../QaDashboardScreenActions';

class QaCoachScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showCoachingSessionNotePopup: false,
            selectedReasonForContact: [],
            comment: undefined
        };
        this.getCompletedAuditsDetailsNode = this.getCompletedAuditsDetailsNode.bind(this);
        this.getCoachingSessionNotePopup = this.getCoachingSessionNotePopup.bind(this);
        this.setSelectedReasonForContact = this.setSelectedReasonForContact.bind(this);
        this.postJibeSession = this.postJibeSession.bind(this);

        this.showCoachingSessionNotePopup = this.showCoachingSessionNotePopup.bind(this);
        this.hideCoachingSessionNotePopup = this.hideCoachingSessionNotePopup.bind(this);        
    }

    componentDidMount() {
        const
            {
                selectedQaSurveyform,
            } = this.props;
        pageLoaded('QA');
        this.props.dispatch(loadQaCoachScreen(this.props.params?.agentId, selectedQaSurveyform.id));
    }

    backToSearch = () => {
        this.props.dispatch(updateProps({
            selectedAgentToCoach: undefined,
            currentAgentCompletedAuditsDetails: undefined,
        }));
        history.push('/QualityAssurance/status');
    }

    showCoachingSessionNotePopup() {
        this.setState({ showCoachingSessionNotePopup: true });
    }

    hideCoachingSessionNotePopup() {
        this.setState({ showCoachingSessionNotePopup: false });
    }

    setSelectedReasonForContact(selectedOption) {
        this.setState({ selectedReasonForContact: selectedOption });
    }

    setComment(value) {
        this.setState({ comment: value })
    }

    postJibeSession() {
        const
            {
                selectedAgentToCoach,
            } = this.props;
        if (!arrayIsNotEmpty(this.state.selectedReasonForContact)) {
            return;
        }

        const coachingSession = {
            agentId: selectedAgentToCoach.agentId,
            reasonForContactId: this.state.selectedReasonForContact[0].id,
            note: this.state.comment
        }

        this.props.dispatch(postCoachingSession(coachingSession));

        this.backToSearch();
    }

    getCompletedAuditsDetailsNode() {
        const
            {
                selectedAgentToCoach,
                selectedQaSurveyform,
                currentAgentCompletedAuditsDetails
            } = this.props;
        return <div>
            <AgentAuditsSummary
                selectedAgentToCoach={selectedAgentToCoach}
                selectedQaSurveyform={selectedQaSurveyform}
                completedAuditsDetails={currentAgentCompletedAuditsDetails} />
        </div>
    }

    getCoachingSessionNotePopup() {
        const
            {
                reasonsForContact,
            } = this.props;

        if (!reasonsForContact)
            return;

        const coachAgentStyle = arrayIsNotEmpty(this.state.selectedReasonForContact) && isDefined(this.state.selectedReasonForContact[0]) ? '#49C2CB' : '#E9E9E9';

        const coachAgentButton = (
            <div className="v3-button" onClick={this.postJibeSession}
                style={{ display: 'inline-flex', marginRight: '10px', backgroundColor: coachAgentStyle }}>
                Submit
            </div>);
        return (<div className="modal displayBlock" >
            <div className="modal-content modal-content-coaching-note">
                <div className="flex flex-flex-end">
                    <Close className="cursor-pointer" onClick={() => this.hideCoachingSessionNotePopup()} />
                </div>
                <SelectTable
                    closeOnClickOutside={true}
                    title="Select coaching reason for contact:"
                    searchPlaceHolder="Search..."
                    setSelectOptions={this.setSelectedReasonForContact}
                    options={reasonsForContact} />
                <div style={{ margin: '30px 0 5px 0' }}>Notes</div>
                <div>
                    <textarea className="survey-comment-text-area"
                        name="postContent"
                        onChange={e => this.setComment(e.target.value)}
                        rows={4} cols={100} />
                </div>
                {coachAgentButton}
            </div>
        </div>);
    }

    render() {
        const backButton = (<div style={{ margin: '4px' }}>
            <Link className="flex " onClick={() => this.backToSearch()}>
                <span className="cursor-pointer" ><BackArrowIcon /></span>
                <Label className="cursor-pointer" style={{ fontSize: '18px', marginLeft: '8px' }} >{'back'}</Label>
            </Link>
        </div>);
        const coachingSessionNotePopup = this.state.showCoachingSessionNotePopup
            ? this.getCoachingSessionNotePopup()
            : undefined;

        const coachAgentButton = (
            <div className="v3-button" style={{ display: 'inline-flex', marginRight: '10px', backgroundColor: '#49C2CB' }}
                onClick={this.showCoachingSessionNotePopup}>
                Coach Agent
            </div>);

        let completedAuditsDetailsNode = this.getCompletedAuditsDetailsNode();
        return <div className="main-page-width">
            {backButton}
            {coachingSessionNotePopup}
            {completedAuditsDetailsNode}
            <div className="teams-table-for-manager filter-area-title-wrapper">
                {coachAgentButton}
            </div>
        </div>
    }
}

const select = state => ({ ...state.session, ...state.QaDashboardManagerScreen });

export default connect(select)(QaCoachScreen);